export default {"src":"/_next/static/media/arrow-carousel-left.0527f6b6.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};